// extracted by mini-css-extract-plugin
export default {"dialogWrap":"dialogUserCUR_dialogWrap__U12aM"};